module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 for (var i in reviewers) { 
__p+='\n<div class="row reviewer-row well ';
 if (reviewers[i].status == 'DELETED') { 
__p+=' deprecated-header ';
 } 
__p+='">\n    <div class="col-md-4">\n        Organization:\n        ';
 if ((reviewers[i].organizationId || '') !== "") { 
__p+='\n            <div class="form-inline" id="'+
((__t=( reviewers[i].uuid + reviewers[i].organizationId ))==null?'':__t)+
'">\n                <a href="/#organization/'+
((__t=( reviewers[i].organizationId ))==null?'':__t)+
'" target="_blank">'+
((__t=( getName(reviewers[i].organizationId) ))==null?'':__t)+
'</a>\n            ';
 if (byAdmin) { 
__p+='\n                <span class="glyphicon glyphicon-pencil clickable reassign-organization" uid="'+
((__t=( reviewers[i].uuid ))==null?'':__t)+
'" aria-hidden="true" title="Re-assign"></span>\n            ';
 } 
__p+='\n                        </div>\n        ';
 } else { 
__p+='\n            <div class="form-inline" id="'+
((__t=( reviewers[i].uuid + reviewers[i].organizationId ))==null?'':__t)+
'">\n                ';
if(byAdmin){
__p+='\n                    <button type="button" class="btn btn-success btn-md assign-organization btn-xs" class="toggle" uid="'+
((__t=( reviewers[i].uuid ))==null?'':__t)+
'">ASSIGN</button>\n                ';
}
__p+='\n            </div>\n        ';
 } 
__p+='\n    </div>\n    <div class="col-md-4">\n        Person:\n        ';
 if ((reviewers[i].personId || '') !== "") { 
__p+='\n        <div class="form-inline" id="'+
((__t=( reviewers[i].uuid + reviewers[i].personId ))==null?'':__t)+
'"><a href="/#person/'+
((__t=( reviewers[i].personId ))==null?'':__t)+
'" target="_blank">'+
((__t=( getName(reviewers[i].personId) ))==null?'':__t)+
'</a>\n                    ';
if(canChangeReviewer(reviewers[i])==true && reviewers[i].status != 'SIGNED' && reviewers[i].status != 'VIEWED'){
__p+='\n                    <span class="glyphicon glyphicon-pencil clickable reassign-person" uid="'+
((__t=( reviewers[i].uuid ))==null?'':__t)+
'" aria-hidden="true" title="Re-assign"></span>\n                    ';
}
__p+='\n                </div>\n        ';
 if (reviewers[i].signedByPersonId && reviewers[i].signedByPersonId != reviewers[i].personId && (reviewers[i].status == 'SIGNED' || reviewers[i].status == 'VIEWED')) { 
__p+='\n        <div class="col-md-6">\n            Signed by: <div class="form-inline" id="'+
((__t=( reviewers[i].uuid + reviewers[i].signedByPersonId ))==null?'':__t)+
'">\n                <a href="/#person/'+
((__t=( reviewers[i].signedByPersonId ))==null?'':__t)+
'" target="_blank">'+
((__t=( getName(reviewers[i].signedByPersonId, reviewers[i].uuid) ))==null?'':__t)+
'</a></div>\n        </div>\n        ';
 } 
__p+='\n        ';
 } else if (typeof(reviewers[i].organizationId) !== "undefined") {
__p+='\n        <div class="form-inline" id="'+
((__t=( reviewers[i].uuid + reviewers[i].personId ))==null?'':__t)+
'">\n                    ';
if(canChangeReviewer(reviewers[i])==true && reviewers[i].status != 'SIGNED' && reviewers[i].status != 'VIEWED'){
__p+='\n                        <button type="button" class="btn btn-success btn-md assign-person btn-xs" class="toggle" uid="'+
((__t=( reviewers[i].uuid ))==null?'':__t)+
'">ASSIGN</button>\n                    ';
}
__p+='\n                </div>\n        ';
}
__p+='\n    </div>\n\n    <div class="col-md-2">\n        '+
((__t=( getReviewerStatusText(reviewers[i].status) ))==null?'':__t)+
'\n    </div>\n\n    <div class="col-md-2">\n        ';
 if (reviewers[i].status != 'SIGNED' && reviewers[i].status != 'VIEWED') { 
__p+='\n            ';
 if (canUserChangeStatus(reviewers[i])==true) { 
__p+='\n            <button type="button" class="btn btn-success btn-xs" ';
 if (reviewers[i].status == 'UNDER_REVIEW') { 
__p+=' disabled ';
 } 
__p+='\n                    id="sign" uid="'+
((__t=( reviewers[i].uuid ))==null?'':__t)+
'" data-value="'+
((__t=( reviewers[i].mandatory ))==null?'':__t)+
'">Sign</button>\n            ';
 } 
__p+='\n            ';
 if (canEdit() || canUploadForOrganizationInDocument()) { 
__p+='\n            <button type="button" class="btn btn-danger btn-xs" id="delete" uid="'+
((__t=( reviewers[i].uuid ))==null?'':__t)+
'">Won\'t sign</button>\n            ';
 }
__p+='\n        ';
 } else { 
__p+='\n            '+
((__t=( fmtTime(reviewers[i].time) ))==null?'':__t)+
'\n        ';
 } 
__p+='\n    </div>\n</div>\n';
 } 
__p+='\n\n<div class="password-confirmation-div"></div>\n<div id="obsolete-confirmation-modal"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/documents/document-reviewers.html
// module id = 407
// module chunks = 0